var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlocked2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-m-blocked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-299",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.674 75.5372C44.947 76.0672 46.295 76.0672 47.284 76.4912C46.115 78.6482 45.088 81.2642 44.277 83.5972C44.202 83.8802 44.06 84.5872 43.89 84.9042C43.815 84.8692 43.815 84.8692 43.711 84.8332C43.466 84.7272 43.211 84.6212 42.966 84.5152C41.976 84.0912 39.714 84.4792 38.724 84.0552C40.214 81.6522 42.722 78.2582 43.674 75.5372Z",
    fill: "#FDB058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-298",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.442 70.5535C38.659 69.6345 39.432 68.6445 39.894 67.7605C40.639 66.3115 41.412 64.8975 42.194 63.4475C42.684 64.1545 42.401 65.6395 42.788 66.3825C43.25 67.2305 44.136 67.9375 45.163 68.3965C47.708 69.5985 51.205 69.7755 54.241 70.0585C53.223 72.3205 51.95 74.3005 48.161 74.3355C46.153 74.3715 42.015 73.5935 40.28 72.9575C38.546 72.3915 38.018 72.4265 38.442 70.5535Z",
    fill: "#692F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-297",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.439 46.6265C35.38 46.5845 35.321 46.5405 35.264 46.4955C35.144 46.4015 35.021 46.2885 34.995 46.1385C34.965 45.9625 35.076 45.7965 35.181 45.6525C36.194 44.2705 37.325 42.8325 38.945 42.2745C40.273 41.8165 41.728 42.0235 43.117 42.2365C45.878 42.6595 48.639 43.0815 51.4 43.5045C53.193 43.7785 60.022 44.6645 59.125 47.8975C58.861 48.8505 57.629 49.0705 56.641 49.0945C50.89 49.2355 45.126 48.8515 39.444 47.9485C38.043 47.7245 36.588 47.4445 35.439 46.6265Z",
    fill: "#2CBA94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-296",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.854 50.5806C59.506 52.8196 57.265 54.9896 54.974 55.4216C52.683 55.8536 50.343 55.1816 48.014 55.0656C47.37 55.0336 46.679 55.0576 46.153 55.4286C45.537 55.8616 45.304 56.6496 45.111 57.3776C38.731 81.5076 33.372 105.907 29.053 130.489C28.183 135.438 27.35 140.48 25.37 145.132C23.233 150.156 17.64 149.925 12.819 151.145C9.008 152.109 5.084 153.799 3 157.133C9.45 138.759 8.385 118.638 12.473 99.5986C15.974 83.2876 23.191 68.0496 30.35 52.9806C30.906 51.8096 31.502 50.5886 32.548 49.8226C34.438 48.4366 37.055 48.9826 39.348 49.4666C45.744 50.8166 52.345 51.1926 58.854 50.5806Z",
    fill: "#2CBA94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-295",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.774 56.8376C43.919 57.7566 43.287 61.4326 43.391 63.9436C43.466 65.0036 43.749 66.0286 44.456 66.9126C45.446 68.1496 47.529 68.3976 49.292 68.6796C49.688 68.7506 54.316 69.3866 54.382 69.2796C55.834 65.9566 57.851 57.1196 57.776 56.8726C54.778 56.5546 50.706 56.1306 47.774 56.8376Z",
    fill: "#FDB058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-294",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.901 87.4615C52.541 92.7935 55.71 104.234 55.269 114.474C54.815 125.02 51.46 135.283 51.045 145.831C51.01 146.717 51.036 147.709 51.66 148.339C52.958 149.647 55.084 148.17 56.304 146.789C64.152 137.9 73.1581 130.034 83.023 123.453C85.46 121.827 88.165 120.221 91.089 120.393C93.612 120.541 95.848 121.994 97.934 123.421C109.187 131.115 120.015 139.43 130.352 148.316C138.016 154.904 146.404 162.212 156.511 162.265C158.679 162.276 161.011 161.978 162.872 163.092C165.896 164.902 165.634 168.947 164.688 171.859C163.297 176.141 159.219 175.63 155.226 175.929C119.742 178.582 83.878 174.503 48.592 179.093C44.623 179.609 40.516 180.226 36.678 179.09C28.865 176.778 24.846 168.163 23.053 160.215C19.66 145.174 20.787 129.432 23.746 114.3C25.379 105.95 27.643 97.5255 32.419 90.4845C33.961 88.2105 36.075 85.9335 38.818 85.7745C40.324 85.6875 41.791 86.2705 43.111 87.0005C43.379 87.1475 43.642 87.3015 43.901 87.4615Z",
    fill: "#FC8264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-293",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.783 88.5743C44.789 88.5453 44.796 88.5173 44.803 88.4883C45.186 87.0943 47.245 87.4023 48.555 88.0163C70.037 98.0823 92.22 107.3 115.65 111.02C116.172 111.103 116.752 111.216 117.06 111.646C117.291 111.968 117.31 112.394 117.287 112.79C116.934 119.011 110.338 120.755 105.225 120.858C87.623 121.212 70.275 117.085 53.154 112.982C52.344 112.788 51.49 112.57 50.904 111.979C50.336 111.407 50.119 110.585 49.923 109.804C48.248 103.118 46.573 96.4323 44.898 89.7463C44.802 89.3633 44.705 88.9593 44.783 88.5743Z",
    fill: "#FC8264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-292",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.774 174.904C167.018 171.874 167.263 168.843 167.507 165.813C167.564 165.104 167.625 164.381 167.906 163.727C168.107 163.26 168.413 162.847 168.716 162.438C171.378 158.853 174.104 155.204 177.757 152.637C174.096 160.067 170.427 167.493 166.774 174.904Z",
    fill: "#D53E20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-291",
    d: "M47.67 104.346C43.645 118.274 42.721 143.195 44.983 179.11",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-290",
    d: "M32.154 108.624C28.233 121.385 29.109 144.22 34.841 177.166",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-289",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.815 132.484C132.725 134.817 117.2 114.456 116.955 115.446C116.672 116.436 114.655 121.633 114.655 121.633C114.655 121.633 122.083 130.611 126.815 132.484Z",
    fill: "#FDB058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-288",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2649 184.838C34.8379 185.399 34.5129 186.392 35.1709 186.645C35.4369 186.747 35.7319 186.64 35.9949 186.53C38.0249 185.679 42.8729 183.74 43.2519 181.527C42.8169 181.402 42.4529 181.462 41.9999 181.489C39.3749 181.643 36.2689 181.579 34.7549 179.43C34.6059 179.219 34.4489 178.973 34.1959 178.927C33.9799 178.888 33.7719 179.011 33.5869 179.129C29.2389 181.903 24.7939 184.766 21.6899 188.885C26.5089 189.392 31.5089 187.902 35.2649 184.838Z",
    fill: "#FDB058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-287",
    d: "M156.511 162.264C156.511 162.264 145.45 162.591 124.221 143.344C102.992 124.097 94.47 120.367 91.089 120.392",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-286",
    d: "M76.386 177.019C76.386 177.019 131.355 176.68 140.517 176.001",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-285",
    d: "M21.07 148.785C21.07 148.785 20.8651 86.0513 38.817 85.7723C56.769 85.4933 53.8741 94.3703 77.801 100.351",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-284",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.181 31.034C146.417 29.2845 155.216 31.6923 161.774 36.8959C164.427 39.0001 166.721 41.5663 168.454 44.4798C172.31 50.9637 173.547 58.8251 172.602 66.3087C171.658 73.7923 168.629 80.9155 164.523 87.2438C161.377 92.0915 157.523 96.5787 152.684 99.7393C147.845 102.9 141.94 104.652 136.219 103.825C131.258 103.109 126.727 100.525 122.881 97.3125C114.383 90.214 108.784 79.7937 107.357 68.8138C106.247 60.2709 107.762 51.0799 113.097 44.3171C118.995 36.8393 128.436 33.423 137.381 31.2171C137.647 31.1517 137.913 31.0907 138.181 31.034Z",
    fill: "#F7CFD1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-283",
    d: "M158.164 37.7787L120.125 95.1514",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-282",
    d: "M136.804 33.7136C116.966 34.18 101.262 50.641 101.729 70.4791C102.179 89.6618 117.623 105.104 136.806 105.556C156.645 105.556 176.68 85.4507 176.68 65.6823C176.662 47.4529 158.561 33.7136 136.804 33.7136Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-281",
    d: "M136.804 33.7136C116.966 34.1801 101.262 50.6411 101.729 70.4791C102.179 89.6618 117.623 105.104 136.806 105.556C156.645 105.556 176.68 85.4507 176.68 65.6824C176.662 47.4529 158.561 33.7136 136.804 33.7136Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlocked2);
export default __webpack_public_path__ + "static/media/icon-blocked-2.c3a44c4acdcf5a4e08330b8543e4422c.svg";
export { ForwardRef as ReactComponent };